import { useEffect, useState } from 'react';

// Keep navigation choices across reloads in this browser tab. Never store forms.
export function readSessionSelection(key, fallback) {
  try { return JSON.parse(sessionStorage.getItem(`fed-selection:${key}`)) ?? fallback; }
  catch { return fallback; }
}

export function saveSessionSelection(key, value) {
  try { sessionStorage.setItem(`fed-selection:${key}`, JSON.stringify(value)); }
  catch { /* Navigation still works when storage is unavailable. */ }
}

export function useSessionSelection(key, fallback) {
  const [value, setValue] = useState(() => readSessionSelection(key, fallback));
  useEffect(() => { saveSessionSelection(key, value); }, [key, value]);
  return [value, setValue];
}
